import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Form, Button, ButtonToolbar } from "react-bootstrap";
import { Formik } from "formik";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Helper
import yup from "../../helpers/Validation";

// Component
import Icon from "../Icon";
import Color from "../../assets/color";

let fields = {
  amount: "",
  payment: "Molpay",
};

const schema = yup.object({
  amount: yup
    .number()
    .typeError("Please enter digits only.")
    .required("Please enter top up amount.")
    // .integer("Only numbers are allowed.")
    .min(5, "Minimum top up amount is RM 5.")
    .max(1000, "Maximum top up amount is RM 1000."),
});

class ModalTopUp extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _onSubmit = () => {
    const form = this.form;

    if (JSON.stringify(form.state.errors) === JSON.stringify({})) {
      let params = form.state.values;
      params.returnUrl =
        window.location.href + (window.location.search === "" ? "/?" : "&");
      this.props.onLoadWalletTopUp(params);
    }
  };

  _hideModal = () => {
    this.props.onHideModalTopUp();
  };

  _onSelectAmount = (amount) => {
    const form = this.form;
    form.setFieldValue("amount", amount);
  };

  render() {
    const { modalTopUpVisible, topUpAmount } = this.props;
    return (
      <Modal
        size="xs"
        show={modalTopUpVisible}
        onHide={this._hideModal}
        aria-labelledby="example-modal-sizes-title-lg"
        centered={true}
        className="modal-top-up"
        backdrop="static"
      >
        <div className="inner-container">
          <div className="position-relative text-right">
            <div
              className="btn-close"
              onClick={() => {
                this.props.clearQuantity();
                this._hideModal();
              }}
            >
              <Icon
                type="custom"
                name="closecircle"
                color={Color.black}
                size={30}
              />
            </div>
          </div>

          <h3>Top Up</h3>
          <Formik
            ref={(el) => (this.form = el)}
            validationSchema={schema}
            onSubmit={this._onLogin}
            initialValues={fields}
            validateOnBlur={true}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              isValid,
              errors,
            }) => {
              if (topUpAmount) {
                if (topUpAmount === "-1") {
                  // reset values.amount back to nothing
                  values.amount = "";
                } else if (topUpAmount !== "" && topUpAmount !== undefined) {
                  // set values.amount to missing amount
                  values.amount = topUpAmount;
                }
                this.props.clearAmount();
              }
              // fix to 2 decimal
              if (!isNaN(parseFloat(values.amount))) {
                let x = values.amount.toString();
                let y = x.split(".");
                if (y[1] && y[1].length > 2) {
                  values.amount = parseFloat(
                    x.substring(0, x.length - 1)
                  ).toFixed(2);
                }
              }
              return (
                <Form
                  noValidate
                  className="h-100 d-flex flex-column flex-grow-1 justify-content-between"
                  onSubmit={handleSubmit}
                >
                  <Form.Group>
                    <Form.Label>Top Up Amount (RM)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Top Up Amount (RM)"
                      name="amount"
                      value={values.amount}
                      onChange={(data) => {
                        handleChange(data);
                      }}
                      onBlur={handleBlur}
                      isInvalid={!!errors.amount}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.amount}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <ButtonToolbar>
                    <Button
                      variant="outline-dark"
                      className="mr-2 mb-2"
                      onClick={() => this._onSelectAmount(10)}
                    >
                      RM 10
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="mr-2 mb-2"
                      onClick={() => this._onSelectAmount(20)}
                    >
                      RM 20
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="mr-2 mb-2"
                      onClick={() => this._onSelectAmount(30)}
                    >
                      RM 30
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="mr-2 mb-2"
                      onClick={() => this._onSelectAmount(50)}
                    >
                      RM 50
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="mr-2 mb-2"
                      onClick={() => this._onSelectAmount(100)}
                    >
                      RM 100
                    </Button>
                  </ButtonToolbar>
                </Form>
              );
            }}
          </Formik>
        </div>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              this.props.clearQuantity();
              this.props.onHideModalTopUp();
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={this._onSubmit}>
            Top Up
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
ModalTopUp.propTypes = {
  modalTopUpVisible: PropTypes.bool.isRequired,
  topUpSuccess: PropTypes.bool.isRequired,
  // Function
  onHideModalTopUp: PropTypes.func.isRequired,
  onLoadWalletTopUp: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    modalTopUpVisible: state.App.modalTopUpVisible,
    topUpAmount: state.App.amount,
    topUpSuccess: state.Wallet.topUpSuccess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onHideModalTopUp: () => dispatch(actions.hideTopUpModal()),
    clearAmount: () => dispatch(actions.clearTopUpAmount()),
    clearQuantity: () => dispatch(actions.clearQuantity()),
    onLoadWalletTopUp: (params) => dispatch(actions.loadWalletTopUp(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalTopUp);
